export const BOOK_TOUR_PERIODS = Array.from({ length: 8 }, (_, index) => {
  const startHour = 9 + index;
  const padHour = (hour: number): string => `${String(hour).padStart(2, '0')}:00`;

  return `${padHour(startHour)} - ${padHour(startHour + 1)}`;
});
